import gsap from "gsap";
import { GameStates } from "onearm";
import { SubGameState } from "./SubGameState";

export class FreespinOutro extends SubGameState {
    /**
     * Enter freespin outro flow.
     * @returns {void}
     */
    enter() {
        super.enter();

        this.hud.setFreeSpinsCounter(0);
        this._balance = 0;
        this._balance = this.gameLogic.balance - this.gameLogic.getFreeSpinsTotalWin();

        if (this.data.skipScreen) {
            this.balance = this.gameLogic.balance;
            this.gameState.goTo(GameStates.IDLE);
        } else {
            const freeSpins = this.gameLogic.getCurrentFreeSpins();

            this.outroPopup = this.scenes.add('FreeSpinOutroPopup', {
                ...freeSpins,
                totalWin: freeSpins.totalWin,
                // totalWin: 1000,
                // total: 10
            });

            const tl = gsap.timeline();

            tl.to({}, {duration: 0.5});
            tl.add([
                this.outroPopup.show(),
                gsap.to(this, { balance: this.gameLogic.balance, duration: 2 }),
            ]);
            tl.add("skipScreen", "-=0.4");
            tl.add([
                this.hud.toMainGameModeAnimation(),
                this.gameState.setBaseGameMode(),
            ]);
            tl.add(() => {
                this.gameState.goTo(GameStates.IDLE);
            });

            this.outroPopup.interactive = true;
            this.outroPopup.interactiveChildren = true;
            this.outroPopup.eventMode = "static";

            this.outroPopup.on("pointerdown", () => {
                tl.seek("skipScreen", false);
                this.outroPopup.interactive = false;
                this.outroPopup.interactiveChildren = false;
                this.outroPopup.eventMode = "none";
            });
        }
    }

    set balance(value) {
        this._balance = value;
        this.hud.setBalance(value);
    }

    get balance() {
        return this._balance;
    }

    exit() {
        super.exit();
        this.scenes.remove("FreeSpinOutroPopup");
        this.hud.setMainGameState();
        this.autoplay.stop();
        this.hud.showAutoplayButton();
        const infoTexts = ["PLACE YOUR BETS! ","SPIN TO WIN!","HOLD SPACE FOR TURBO SPIN"];
        this.hud.setInfoText(infoTexts[Math.floor(Math.random() * infoTexts.length)]);
        this.hud.setPaysText("FREE SPINS FINISHED!");

        this.audio.playMusic("basegame_loop", { loop: true });
        this.audio.stopMusic("freegame_loop");
        this.audio.playSfx("transition");
    }

    spin() {
        // skip
    }
}



